/* eslint-disable */
const mainMixins = {
    data() {
        return {

        }
    },
    methods: {
        async getUserApi() {
            if(!user) {
                if(headers) {
                    if(localStorage.userETC) {
                        await axios.post(apiKS + 'api/userdecrypt', {usuario: localStorage.userETC}, { headers })
                        .then( response => {
                            user = JSON.parse(response.data.user)
                        }).catch( error => {
                            this.catchError(error)
                        })
                    }else{
                        router.replace('/login')
                    }
                }else{
                    router.replace('/login')
                }
            }
        },
        async getPaises() {
            await axios.get(apiKS + 'api/paises', { headers: clientAPI })
            .then( ({ data }) => (this.paises = data.data))
            .catch( error => {
                this.catchError(error)
            })
        },
        async getIdiomas() {
            await axios.get(apiKS + 'api/idiomas', { headers: clientAPI })
            .then( ({ data }) => (this.idiomas = data.data))
            .catch( error => {
                this.catchError(error)
            })
        },
        async getEstados(value) {
            await axios.get(apiKS + 'api/estados?id_pais=' + value, { headers: clientAPI })
            .then( ({ data }) => (this.estados = data.data))
            .catch( error => {
                this.catchError(error)
            })
        },
        async getCiudades(value) {
            await axios.get(apiKS + 'api/ciudades?id_estado=' + value, { headers: clientAPI })
            .then( ({ data }) => (this.ciudades = data.data))
            .catch( error => {
                this.catchError(error)
            })
        },
        async getZonasHorarias() {
            await axios.get(apiKS + 'api/zonashorarias', { headers: clientAPI })
            .then( ({ data }) => (this.zonashorarias = data.data))
            .catch( error => {
                this.catchError(error)
            })
        },

        async saveDataNoForm(url, model, urlReturn, emitEvent, closemodal, clearmodel, tipoMensaje, modelOriginal) {
            this.openLoading()
            await axios.post(apiKS + url, model, { headers })
            .then( response => {
                Swal.close()
                if (response.data.status == true) {
                    if(tipoMensaje == 1 || tipoMensaje == undefined || tipoMensaje == null || tipoMensaje == 3) {
                        if(this.$route.path == '/checkout') {
                            this.$store.commit('setProductos', [])
                            this.$store.commit('setTotal', 0)
                            this.$store.commit('setCupon', '')
                        }
                        Swal.fire({
                            title: "Exito",
                            text: response.data.message,
                            icon: "success",
                            onClose: () => {
                                if(urlReturn != '' && tipoMensaje == 1)
                                    router.push(urlReturn)
                                if(urlReturn != '' && tipoMensaje == 3)
                                    location.reload()
                            }
                        })
                    }else{
                        var $toast = toastr['success'](response.data.message, 'Exito')
                    }

                    if(emitEvent != '') {
                        Fire.$emit(emitEvent)
                    }
                    if(closemodal) {
                        this.closeModal(closemodal)
                    }
                    if(clearmodel == 1) {
                        this.clearModel()
                    }
                    if(clearmodel == 2) {
                        this.clearModelPartidas(modelOriginal)
                    }
                }
                if (response.data.status == false) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: response.data.message,
                    })
                }
            })
            .catch( error => {
                //this.catchError(error)
            })
        },

        async updateDataNoForm(url, model, urlReturn, emitEvent, closemodal, clearmodel, tipoMensaje, modelOriginal) {
            this.openLoading()

            await axios.put(apiKS + url, model, { headers })
            .then( response => {
                Swal.close()
                if (response.data.status == true) {
                    if(tipoMensaje == 1 || tipoMensaje == undefined || tipoMensaje == null) {
                        Swal.fire({
                            title: "Exito",
                            text: response.data.message,
                            type: "success",
                            onClose: () => {
                                if(urlReturn != '')
                                    router.push(urlReturn)
                            }
                        })
                    }else{
                        var $toast = toastr['success'](response.data.message, 'Exito')
                    }

                    if(emitEvent != '') {
                        Fire.$emit(emitEvent)
                    }
                    if(closemodal) {
                        this.closeModal(closemodal)
                    }
                    if(clearmodel == 1) {
                        this.clearModel()
                    }
                    if(clearmodel == 2) {
                        this.clearModelPartidas(modelOriginal)
                    }
                }
                if (response.data.status == false) {
                    var $toast = toastr['error'](response.data.message, 'Error');
                }
            })
            .catch( error => {
                // this.catchError(error)
            })
        },

        async register(url, model, urlReturn, emitEvent, closemodal, clearmodel, tipoMensaje, modelOriginal) {
            this.openLoading()
			await grecaptcha.execute('6Ldv78EZAAAAAFapAMeP1FaE4JYQDaZhsTskA119')
            .then((token) => {
			    this.model.captchaToken = token
            });

            await axios.post(apiKS + url, model, { headers: clientAPI })
            .then( response => {
                Swal.close()
                if (response.data.status == true) {
                    if(tipoMensaje == 1 || tipoMensaje == undefined || tipoMensaje == null || tipoMensaje == 3) {
                        Swal.fire({
                            title: "Exito",
                            text: response.data.message,
                            icon: "success",
                            onClose: () => {
                                if(urlReturn != '' && tipoMensaje == 1)
                                    router.push(urlReturn)
                                if(urlReturn != '' && tipoMensaje == 3)
                                    location.reload()
                            }
                        })
                    }else{
                        var $toast = toastr['success'](response.data.message, 'Exito')
                    }

                    if(emitEvent != '') {
                        Fire.$emit(emitEvent)
                    }
                    if(closemodal) {
                        this.closeModal(closemodal)
                    }
                    if(clearmodel == 1) {
                        this.clearModel()
                    }
                    if(clearmodel == 2) {
                        this.clearModelPartidas(modelOriginal)
                    }

                    if(this.$route.path.includes('/detalle-producto')) {
                        console.log('Si anda entrando')
                        this.$store.commit("setDescuento", response.data.descuento)
                        this.$store.commit('setCupon', this.form.codigoCupon)
                    }
                }
                if (response.data.status == false) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: response.data.message,
                    })
                }
            })
            .catch( error => {
                this.catchError(error)
            })

        },

        async deleteDataNoForm(url, loadData, emitEvent) {
            
        },

        openLoading() {
            Swal.fire({
                title: 'Espere por favor...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
                onOpen: () => {
                    Swal.showLoading()
                }
            })
        },

        catchError(error) {
            Swal.close()
            if(error.response.status == 401)
                router.replace('/login')
            if(error.response.status == 500 || error.response.status == 404 || error.response.status == 405){
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error.response.statusText + ' ' + error.response.data.message,
                })
            }
        },

        async getProductos(url) {
            await axios.get(apiKS + url, { headers: clientAPI })
            .then( ({ data }) => (this.productosCatalogo = data.data))
            .catch( error => {
                this.catchError(error)
            })
        },

        async getProductosUsuario(id_usuario) {
            await axios.get(apiKS + 'api/productosusuario?id_usuario=' + id_usuario, { headers: clientAPI })
            .then( ({ data }) => (this.productosusuario = data))
            .catch( error => {
                this.catchError(error)
            })
        },

        async loadData(url) {
            this.openLoading()

            await axios.get(apiKS + url, { headers: clientAPI })
            .then( response => {
                if(response.data.data) {
                    for(var prop in response.data.data) {
                        this.model[prop] = response.data.data[prop]
                    }

                } else {
                    for(var prop in response.data) {
                        this.model[prop] = response.data[prop]
                    }
                }
                /*if(response.data.id_pais != null && response.data.id_pais != '')
                    this.getEstados(response.data.id_pais, response.data.id_estado)
                if(response.data.id_estado != null && response.data.id_estado != '')
                    this.getCiudades(response.data.id_estado)
                if(response.data.id_cliente != null)
                    this.getCliente(response.data.id_cliente, 0)
                if(response.data.id_proveedor != null)
                    this.getProveedor(response.data.id_proveedor, 0)

                if(response.data.datos_mapa != "" && response.data.datos_mapa != null){
                    const coord = response.data.datos_mapa.split(',')
                    this.markers.push({
                        position: {
                            lat: parseFloat(coord[0]),
                            lng: parseFloat(coord[1])
                        }
                    })
                    navigator.geolocation.getCurrentPosition((position) => {
                        this.currentLocation = {
                            lat: parseFloat(coord[0]),
                            lng: parseFloat(coord[1])
                        }
                    })
                }*/
                Swal.close()
            })
            .catch( error => {
                this.catchError(error)
            })
        },

        async getProductosCarrito() {
            if(!this.$store.getters.productos.length && this.$store.getters.usuario) {
                await axios.get(apiKS + 'api/carrito', { headers: {
                    'Content-Type': 'application/json',
                    Authorization: localStorage.tokenETCSistema
                } })
                .then( (response) => {
                    this.$store.commit('setProductos', response.data.productos)
                    this.$store.commit('setTotal', response.data.total)
                })
                .catch( error => {
                    this.catchError(error)
                })
            }
        },

        async getCompras() {
            await axios.get(apiKS + `api/ordenes?id_usuario=${this.$store.getters.usuario.id}`, { headers: clientAPI })
            .then( ({ data }) => (this.compras = data.data))
            .catch( error => {
                this.catchError(error)
            })
        },

        async getClients() {
            await axios.get(apiKS + 'api/clientes?activo=1&aparece_tienda=1', { headers: clientAPI })
            .then( (response) => {
                this.clients = response.data.data
                this.clients.push({id: 0, nombre: 'Sin escuela o institución'})
            })
            .catch( error => {
                this.catchError(error)
            })
        },
    }
}

export default mainMixins